/**
 * Scroll Fix Script
 * Ensures that scroll-blocking classes are properly removed to prevent scroll issues on mobile
 */

(function() {
  'use strict';

  // List of all scroll-blocking classes and their targets
  const scrollBlockers = [
    { element: 'body', classes: ['overflow-hidden', 'drawer-open', 'search-dropdown-open'] },
    { element: 'html', classes: ['no-scroll', 'minicart-no-scroll'] }
  ];

  /**
   * Remove all scroll-blocking classes
   */
  function clearScrollBlockers() {
    scrollBlockers.forEach(function(blocker) {
      const el = blocker.element === 'body' ? document.body : document.documentElement;
      blocker.classes.forEach(function(className) {
        el.classList.remove(className);
      });
    });
  }

  /**
   * Check if any drawers/modals are actually open
   * Only clear scroll blockers if nothing is open
   */
  function clearScrollBlockersIfNeeded() {
    const cartDrawer = document.querySelector('cart-drawer');
    const mobileDrawer = document.querySelector('.mrMobileDrawer');
    const mobileNav = document.querySelector('.action_hamburger .nav');
    const header = document.querySelector('#shopify-section-header');
    
    const isCartOpen = cartDrawer && cartDrawer.classList.contains('active');
    const isMobileMenuOpen = (mobileDrawer && mobileDrawer.classList.contains('open')) || 
                             (mobileNav && mobileNav.classList.contains('open'));
    const isSearchOpen = header && header.classList.contains('searchOpened');
    
    // Only clear if nothing is actually open
    if (!isCartOpen && !isMobileMenuOpen && !isSearchOpen) {
      clearScrollBlockers();
    }
  }

  /**
   * Initialize fixes on page load
   */
  function init() {
    // Clear on initial load (with a small delay to ensure DOM is ready)
    setTimeout(clearScrollBlockersIfNeeded, 100);
    
    // Clear when page becomes visible (fixes iOS Safari bfcache issues)
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) {
        setTimeout(clearScrollBlockersIfNeeded, 100);
      }
    });
    
    // Clear on pageshow (handles back/forward navigation)
    window.addEventListener('pageshow', function(event) {
      // event.persisted indicates page was loaded from cache
      if (event.persisted) {
        setTimeout(clearScrollBlockersIfNeeded, 100);
      }
    });
    
    // Clear before unload
    window.addEventListener('beforeunload', function() {
      clearScrollBlockers();
    });
    
    // Additional check on scroll attempt
    var scrollAttempts = 0;
    window.addEventListener('touchmove', function(e) {
      // If user tries to scroll but can't, check and fix
      if (scrollAttempts++ > 3) {
        clearScrollBlockersIfNeeded();
        scrollAttempts = 0;
      }
    }, { passive: true });
    
    // Reset scroll attempts counter periodically
    setInterval(function() {
      scrollAttempts = 0;
    }, 2000);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Export for debugging
  window.scrollFixDebug = {
    clearAll: clearScrollBlockers,
    clearIfNeeded: clearScrollBlockersIfNeeded,
    checkStatus: function() {
      console.log('Body classes:', document.body.className);
      console.log('HTML classes:', document.documentElement.className);
    }
  };
})();
